import _ from 'lodash';
import {Component, Module} from 'app/decorators';
import tpl from './product_code.picker.html';


@Module({
    name: "app.directives.product_code.picker",
})
@Component({
    selector: 'blnd-product-code-picker',
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C {
    constructor ($scope, Config) {
        "ngInject";
        this.scope = $scope;
        this.mode = this.mode || 'view';
        this.productCodes = Config.$config.product_codes;
    }

    getName () {
        return _.toUpper(this.ngModel);
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/product_code.picker.js